import React from "react";
import { device, theme } from "../../../utils";
import { rgba } from "polished";
import styled from "styled-components";
import LuxWeb3Context from "../../../context/LuxWeb3Context";
import lux_cloud from '../../../assets/image/cult/lux_cloud.jpg';
import claim_sample from '../../../assets/image/cult/neon_claim_demo.png';
import ContentAbout from "./about";
import PrivacyPolicy from "./privacyPolicy";
import TermsOfService from "./termsOfService";
import Returns from "./returns";
import Contact from "./contact";
import ElementCycleChart from "./ElementCycleChart";

const ContentInfoWrap = styled.div`
  position: relative;

  #info-content {
    padding-top: 10px;

    @media ${device.md} {
      padding-top: 20px;
    }



    // HEADER
    .content-header {
      margin-bottom: 10px;
      font-size: 18px;
      @media (max-width: 767px) { font-size: 16px; }
      text-shadow: 0 0 0 #000;
      cursor: pointer;
      text-align: center;
      position: relative;
      left: 50%;
      transform: translateX(-50%);
      max-width: 400px;
      width: 95%;

      @media ${device.sm} {
        font-size: 22px;
        @media (max-width: 767px) { font-size: 20px; }
      }

      @media ${device.md} {
        font-size: 25px;
        margin-bottom: 10px;
      }

      &.cult-button {
        margin-bottom: 15px;
      }

      // STAYS "FILLED IN" (same look as .cult-button:hover) while its
      // accordion panel is open, not just on hover
      &.is-open {
        background: ${theme.cultPalette[0]} !important;
        color: #000 !important;
        text-shadow: none !important;
        box-shadow: 0 0 18px ${rgba(theme.cultPalette[0], 0.55)};
      }
    }

    .text-subheader {
      font-size: 16px;
      @media (max-width: 767px) { font-size: 14px; }
      // text-shadow: 0 0 1px #000;
      margin: 10px 0;
      line-height: 18px;

      @media ${device.md} {
        font-size: 25px;
        line-height: 22px;
        margin-top: 15px;
        margin-bottom: 15px;
      }
    }


    // BODY CONTENT
    .body-wrap {
      height: 0;
      overflow: hidden;

      &.open {
        height: 100%;
        overflow: visible;
      }
    }

    .content-body {
      font-size: 14px;
      @media (max-width: 767px) { font-size: 12px; }
      padding: 0 5px;
      text-align: center;
      
      @media ${device.lg} {
        font-size: 18px;
        padding: 0 90px;
      }

      &.content-entry {
        @media ${device.md} {
          font-size: 20px;
        }
      }

      .content-image {
        width: 100%;
      }

      &.image-wrap img {
        max-width: 850px;
      }

      .exchange-image-wrap {
        position: relative;
        margin-bottom: 40px !important;

        .text-subheader.nft-text,
        .text-subheader.claimed-neon-text {
          position: absolute;
          bottom: -40px;
        }
        .text-subheader.nft-text {
          left: 10px;

          @media ${device.md} {
            left: 87px;
          }
        }
        .text-subheader.claimed-neon-text {
          right: 10px;
          
          @media ${device.md} {
            right: 87px;
          }
        }
      }

      // CULT SUBHEADERS (BUTTON STYLE ONES)
      .cult-button {
        font-size: 16px;
        @media (max-width: 767px) { font-size: 14px; }

        @media ${device.md} {
          font-size: 20px;
        }
      }

      .cult-button-subheader {
        padding-top: 2px;
        padding-bottom: 2px;
        margin-bottom: 12px;
        display: inline-flex;
        // color: #000 !important;
        // background: #eee !important;
      }
  

      .text-bold {
        text-shadow: 0px 0px 1px #000;
        color: ${theme.cultPalette[1] === '#950AFF' ? '#cecece':'inherit'};
      }
    }
  
    // CONTAINMENT TABLE : 3-column spec table (class / description / protocol)
    .containment-table {
      margin-top: 10px;
      border: 1px solid rgba(255, 255, 255, 0.25);
      text-align: left;

      .ct-row {
        display: flex;
        align-items: stretch;
        border-bottom: 1px solid rgba(255, 255, 255, 0.12);
        align-items: center;

        &:last-child {
          border-bottom: none;
        }
      }

      .ct-cell {
        padding: 6px 10px;
        border-right: 1px solid rgba(255, 255, 255, 0.12);
        font-size: 14px;
        @media (max-width: 767px) { font-size: 12px; }

        &:last-child {
          border-right: none;
        }
      }

      .ct-head .ct-cell {
        font-weight: bold;
        text-transform: uppercase;
        letter-spacing: 1px;
        color: rgba(255, 255, 255, 0.85);
        font-size: 12px;
        @media (max-width: 767px) { font-size: 10px; }
      }

      .ct-class { flex: 0 0 26%; }
      .ct-desc { flex: 1 1 auto; }
      .ct-protocol { flex: 0 0 30%; }
    }

    // UTIL
    .text-center {
      text-align: center;
    }
  }
`;

class ContentInfo extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      openTab: null
    }
    this.open = this.open.bind(this);
  }
  static contextType = LuxWeb3Context;

  componentDidUpdate(prevProps, prevState) {
    const { openTab } = this.state;
    const prevTab = prevState.openTab;

    if ( !!openTab && openTab !== prevTab ) {
      this.resetContentScroll( openTab );
    }
  }

  open(e) {
    const id = e.target.id;
    const selection = id && this.state.openTab !== id ? id : null;
    this.setState({openTab: selection});
  }

  // UTIL : class for a content-header accordion button, "filled in" while
  // its own panel is the open one
  headerClass(id) {
    return `content-header cult-button${this.state.openTab === id ? ' is-open' : ''}`;
  }

  resetContentScroll(selection) {
    const scrollBox = document.getElementById('content-scroll-box');
    const scrollTarget = document.getElementById( selection );
    if ( !!scrollBox && !!scrollBox.scrollTo && !!scrollTarget ) {
      scrollBox.scrollTo(0, 0);
      const targetLocation = scrollTarget.getBoundingClientRect();
      const parentLocation = scrollBox.getBoundingClientRect();
      const distanceToScroll = targetLocation.top - parentLocation.top - 20;
      // console.log( `selection top = ${targetLocation.top} \ntarget top    = ${parentLocation.height} \nscroll amount = ${distanceToScroll}` );
      scrollBox.scrollTo(0, distanceToScroll);
    } 
  }

  render() {
    const { openTab } = this.state;

    return (
      <ContentInfoWrap>
          
        <ul id="info-content" ref="">
          <ContentAbout noNftsFound={this.props.noNftsFound}/>
          <br/>

          {/* NEON SPIRITS */}
          <li className={this.headerClass('overview')} id="overview" onClick={this.open} onKeyDown={e => { if (e.key === 'Enter' || e.key === ' ') this.open(e); }} role="button" tabIndex={0}>-\\ LORE //-</li>
          <div className={openTab === 'overview' ? 'body-wrap open': 'body-wrap'}>
            <li className="content-body">
              <i className="cult-link">Neon Spirits</i> are light-based beings from another dimension.
              <br/><br/><br/>
              <div className="cult-button cult-button-subheader cult-button-alt-colors">Elements</div>
              <br/>
              Each neon spirit embodies a single, <i className="cult-link">universal element</i>, with abilities based on its resonance.
              <br/><br/>
              <ElementCycleChart elements={['Time', 'Void', 'Stellar']} color={theme.cultPalette[0]} />
              <ElementCycleChart elements={['Fire', 'Ice', 'Air', 'Earth']} color={theme.cultPalette[1]} />
              <br/><br/><br/>
              <div className="cult-button cult-button-subheader cult-button-alt-colors">Origins</div>
              <br/><i className="cult-link">Afflicted Objects</i> - like the bonsai - manifest when human items are <i className="cult-link">possessed by a neon spirit</i>, causing physical or psychological effects within their presence.
              {/* <br/><br/>Temporal anomalies, matter transfiguration, and teleportation have all been recorded. */}
              {/* <br/><br/>Incidents throughout history have been attributed to powerful Afflicted Objects, and Improper handling when containing one can result in severe injury. */}
              <br/><br/><i className="cult-link">Follow containment protocol at all times.</i>
              <br/><br/><br/><br/>
              <div className="cult-button cult-button-subheader cult-button-alt-colors">Containment Protocols</div>
              <br/>
              <div className="containment-table">
                <div className="ct-row ct-head">
                  <div className="ct-cell ct-class">Class</div>
                  <div className="ct-cell ct-desc">Description</div>
                  <div className="ct-cell ct-protocol">Containment Protocol</div>
                </div>
                <div className="ct-row">
                  <div className="ct-cell ct-class cult-link">Tier I - Luminous</div>
                  {/* <div className="ct-cell ct-desc"><i>Gentle, good-natured spirits. Typically exhibit powers of fortune, infatuation or illusion. A few assist in cult of neon operations.</i></div> */}
                  <div className="ct-cell ct-desc"><i><i className="cult-link">Good-natured</i> spirit safely assimilated in the human realm - some assist cult of neon agents.</i></div>
                  <div className="ct-cell ct-protocol">- Lumen-grade Seal or higher</div>
                </div>
                <div className="ct-row">
                  <div className="ct-cell ct-class cult-link">Tier II - Hex</div>
                  <div className="ct-cell ct-desc"><i><i className="cult-link">Dangerous</i> - negatively affect, attack or consume humans. Use extreme caution.</i></div>
                  <div className="ct-cell ct-protocol">- Radiant-grade Seal<br/>- Elemental containment vessel</div>
                </div>
                <div className="ct-row">
                  <div className="ct-cell ct-class cult-link">Tier III - Celestial</div>
                  <div className="ct-cell ct-desc"><i><i className="cult-link">Catastrophe-level</i> spirit capable of city-wide area manipulation.<br/>Last known encounter : [redacted]</i></div>
                  <div className="ct-cell ct-protocol">- Evacuate & Quarantine<br/>- S+ Rank Team Required</div>
                </div>
              </div>
              <br/><br/>
            </li>
          </div>



          {/* THE NEON */}
          <li className={this.headerClass('shipping')} id="shipping" onClick={this.open} onKeyDown={e => { if (e.key === 'Enter' || e.key === ' ') this.open(e); }} role="button" tabIndex={0}>.|| THE BONSAI ||.</li>
          <div className={openTab === 'shipping' ? 'body-wrap open': 'body-wrap'}>
            <li className="content-body">
              {/* <br/><div className="cult-button cult-button-subheader cult-button-alt-colors">The Bonsai</div> */}
              <br/>Each bonsai are <i className="cult-link">1 of 1 edition, hand-bent glass neon</i> with a custom built bonsai pot transformer crafted to reflect the lore of each piece. Runs quietly via standard US Plug. 
              <br/><br/>Includes authenticity card + hardshell case.
              <br/><br/>---
              <br/><br/><div className="cult-link">In a world of AI slop, our work is only crafted by human hands.</div>
              
              <br/><br/><br/>
              
              {/* SCHEMATIC STUFF WE CAN CUT FOR NOW NO WEB3 CRAP */}
              {/* <div className="cult-button cult-button-subheader cult-button-alt-colors">The Schematic</div>
              <br/>The web3 digital schematic included with each neon is the bending pattern used to craft the neon, and serves as your certificate of authenticity.
              <br/><br/>
              <div className="content-body image-wrap exchange-image-wrap">
                <img className="content-image" alt="Sample of Schematic used for Neon Piece" src={claim_sample}  />
                <div className="text-subheader nft-text">Schematic</div>
                <div className="text-subheader claimed-neon-text">Physical Neon</div>
              </div>
              <br/>
            </li>
            <li className="content-body">
              Included with each neon is an info card with your piece's lore, care and setup guide.
              <br/><br/>
              Once shipped, we'll also send you the web3 <a className="cult-link" href="https://metamask.io/" target="_blank" rel="noreferrer">Metamask wallet</a> holding your neon's schematic on the blockchain, which serves as your digital certificate of authenticity.
              */}
            </li>
            <Contact />
            <br/>
          </div>



          {/* HOW DOES IT WORK */}
          {/* <li className="content-header cult-button" id="howitworks" onClick={this.open} onKeyDown={e => { if (e.key === 'Enter' || e.key === ' ') this.open(e); }} role="button" tabIndex={0}>~// Install Guide \~</li>
          <div className={openTab === 'howitworks' ? 'body-wrap open': 'body-wrap'}>
            <br/> */}

            {/* SECTION - INSTALL GUIDE */}
            {/* <li className="content-body text-center"><i>Each neon includes an info card with matching video install guide.</i></li>
            <br/>
            <li className="content-body text-center"><i>For example - If your neon is wall mounted, the video would walk you through these steps below.</i></li>
            <br/> */}


          {/* INSTALL STEPS BELOW
            <li className="content-body text-center">
              <div className="text-subheader">STEP 1 - Prep</div>
              Find the included mount guide paper & tape it to a wall where you want your neon.
              <br/><br/>
              <div className="text-subheader">STEP 2 - Mark Screw Holes</div>
              Using a pen or pencil, draw in each designated screw hole to mark the points on the wall. 
              <br/><br/>
              <div className="text-subheader">STEP 3 - Loosely Attach Mounts</div>
              Remove mounting guide from wall and Screw included mount clips to each marked spot, leaving the screws juuust tight enough to rotate around the screw as needed in step 4.
              <br/><br/>
              <div className="text-subheader">STEP 4 - Align Clips</div>
              Gently take the neon and align the mount clips so they clip onto neon. Carefully trace the edge of each clip, then put the neon back down and give the clips a final tighten to their marked positions.
              <br/><br/>
              <div className="text-subheader">STEP 5 - Attach Neon</div>
              Gently press the neon into each clip. It should pop in gently. Once secured, plug in your new sign.
              <br/><br/>
              <div className="text-subheader">~// Bask in neon hues \\~</div>
            </li> */}
            
            {/* 
            <br/>
            <br/>
          </div>
          */}


          {/* ARTIST */}
          <li className={this.headerClass('artist')} id="artist" onClick={this.open} onKeyDown={e => { if (e.key === 'Enter' || e.key === ' ') this.open(e); }} role="button" tabIndex={0}>+// ARTIST \+</li>
          <div className={openTab === 'artist' ? 'body-wrap open': 'body-wrap'}>
            <li className="content-body">
              {/* <br/><div className="text-subheader">Creator</div> */}
              <br/><div className="cult-button cult-button-subheader cult-button-alt-colors text-center">LUX_CAPACITOR</div>
              <br/>Artist & Engineer, <a className="cult-link" href="http://lux-capacitor.com" target="_blank" rel="noreferrer">Lux</a> handles all aspects - from schematic design to wiring, development, and fabrication of each piece in meticulous detail.
              <br/><br/>Conjuring designs drafted in daydreams, <b className="cult-link">Cult of Neon</b> is the embodiment of his surrealist obsession with light as a medium, collaborating with local LA artisans to bring luminous visions to life.
              <br/><br/><a className="cult-link" href="http://lux-capacitor.com" target="_blank" rel="noreferrer">lux-capacitor.com</a>
              <br/><br/>
              </li>
              {/* <div className="text-subheader">Benders</div> */}
              {/* <div className="cult-button cult-button-subheader cult-button-alt-colors text-center">Benders</div>
              <br/>Bending is done locally with <a className="cult-link" href="https://lasignstech.com/">LA Signs Tech</a>, summoning forth art into reality. They're a family-run business with decades of skill.
              <br/><br/><a className="cult-link" href="https://lasignstech.com/">LASignsTech.com</a>
            </li>
            <br/>
            <div className="content-body image-wrap">
              <img className="content-image" src={lux_cloud} alt="4ft wide, pastel hue, melting cloud neon artwork by Lux_Capacitor" />
              <i>"Prismatic.Sunset"</i> - One of our many collaborations
            </div> */}
            {/* <br /> */}
          </div>


          {/* ABOUT NEON */}
          <li className={this.headerClass('aboutneon')} id="aboutneon" onClick={this.open} onKeyDown={e => { if (e.key === 'Enter' || e.key === ' ') this.open(e); }} role="button" tabIndex={0}>./? ABOUT NEON ?\.</li>
          <div className={openTab === 'aboutneon' ? 'body-wrap open': 'body-wrap'}>
            <li className="content-body text-center">Modern neon is quiet, cool to the touch and lasts for many years.</li>
            <br/><br/>
            {/* <div className="text-subheader text-center">What is Neon?</div> */}
            <li className="content-body">
              <div className="cult-button cult-button-subheader cult-button-alt-colors text-center">What is Neon?</div>
              <br/>"Neon" is a red-colored, gas element. When electrified in a glass tube under pressure, it emits a deep, red glow.
              <br/><br/>Due to the red color, many neon signs are actually filled with an Argon gas blend which glows white-blue when electrified.
            </li>
            <br/><br/>
            {/* <div className="text-subheader text-center">Colors</div> */}
            <li className="content-body">
              <div className="cult-button cult-button-subheader cult-button-alt-colors text-center">Colors</div>
              <br/>Many colors today are glass coated with colored phosphorous that, when electified, illuminates a bright hue based on the composition, resulting in a wide variety of colors.
              <br/><br/>Glass itself may also be colored to attain a rich hue.
            </li>
            <br/><br/>
            {/* <div className="text-subheader text-center">Bending</div> */}
            <li className="content-body">
              <div className="cult-button cult-button-subheader cult-button-alt-colors text-center">Bending</div>
              <br/>Glass itself - normally rigid - can be surprisingly flexible when subjected to focused heating via specialized torches.
              <br/><br/>
              A bender carefully heats the glass tube, balancing temperature using air and motion to bend it into shape. Mastering the craft can take years of practice, and is an incredible skill to observe in action or try yourself.
            </li>
            <br/><br/>
            <div className="text-subheader text-center">Learn to Bend</div>
            <li className="content-body">
              In Los Angeles, the <a className="cult-link" href="https://neonmona.org" target="_blank" rel="noreferrer"> Museum of Neon Art</a> conducts regular classes in which you can learn to bend your very own neon! Its very fun, we highly suggest checking them out!
              <br/><br/>
              <a className="cult-button" href="https://store.neonmona.org/collections/classes" target="_blank" rel="noreferrer">See Classes</a>
            </li>
            <br/>
            <br/>
          </div>

          {/* MORE INFO */}
          {/*}
          <li className="content-header cult-button" id="utility" onClick={this.open}>=// UTILITY \\=</li>
          <div className={openTab === 'utility' ? 'body-wrap open': 'body-wrap'}>
            <li className="content-body text-center">1 Schematic = 1 Neon Artwork</li>
            <br/>
            <li className="content-body">
              Each Cult of Neon Schematic owned also grants 1 allowlist spot on the future series:
              <br/><i className="text-bold">Cult of Neon - Sacred Artifacts</i>
              <br/><br/>Holders gain early previews & release dates on future 1/1 works
              <br/><br/>More to come..
              <br/><br/>
            </li>
          </div>
          */}

          {/* DIVIDER */}
          <li className="content-header">--------</li>


          {/* PRIVACY + DATA */}
          <li className={this.headerClass('privacy')} id="privacy" onClick={this.open} onKeyDown={e => { if (e.key === 'Enter' || e.key === ' ') this.open(e); }} role="button" tabIndex={0}>.|' PRIVACY POLICY '|.</li>
          <div className={openTab === 'privacy' ? 'body-wrap open': 'body-wrap'}>
            <PrivacyPolicy />
          </div>


          {/* TERMS OF SERVICE */}
          <li className={this.headerClass('terms')} id="terms" onClick={this.open} onKeyDown={e => { if (e.key === 'Enter' || e.key === ' ') this.open(e); }} role="button" tabIndex={0}>!|' TERMS OF SERVICE '|!</li>
          <div className={openTab === 'terms' ? 'body-wrap open': 'body-wrap'}>
            <TermsOfService />
          </div>


          {/* RETURNS */}
          <li className={this.headerClass('returns')} id="returns" onClick={this.open} onKeyDown={e => { if (e.key === 'Enter' || e.key === ' ') this.open(e); }} role="button" tabIndex={0}>:'| RETURNS |':</li>
          <div className={openTab === 'returns' ? 'body-wrap open': 'body-wrap'}>
            <Returns />
          </div>
          
        </ul>
      </ContentInfoWrap>
    );
  }
};

export default ContentInfo;